import 'react-toastify/dist/ReactToastify.min.css';

import { QueryClientProvider } from 'react-query';
import { ToastContainer } from 'react-toastify';
import { ThemeProvider } from 'styled-components';

import { Router } from 'src/router';

import { Document } from 'src/Document';

import GlobalStyles from 'src/assets/styles/global';
import defaultTheme from 'src/assets/styles/themes/default';

import ErrorBoundary from 'src/pages/Errors/ErrorBoundary';

import { queryClient } from 'src/utils/queryClient';

function App() {
  return (
    <ThemeProvider theme={defaultTheme}>
      <Document />
      <GlobalStyles />
      <ToastContainer />
      <ErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <Router />
        </QueryClientProvider>
      </ErrorBoundary>
    </ThemeProvider>
  );
}

export default App;
